var domain = document.location.protocol + '//' + document.location.hostname;

$(function(){

  // open raw xml mode in new tab on ctrl+alt+r
  var url = window.location + '';
  if (location.href.split(location.host)[1].indexOf('/tangelo/page/') == 0) {
    $(window).keypress(function(e){
      var code = e.keyCode || e.which;
      if(code == 174 && e.ctrlKey && e.altKey) {
        var urlBase = url.split('?')[0];
        var urlParams = url.split('?')[1] ? '?' + url.split('?')[1] : '';
        var newUrl = urlBase + '/raw' + urlParams;
        window.open(newUrl,'_blank');
      }
    });
  }

  // website exit
  $.expr[':'].external = function (a) {
    return a.href.indexOf('http') == 0 && a.href.indexOf(domain) != 0;
  };
  $('a:external').each(function(){
    $(this).attr('target','_blank');
  });

  // build email links (spam prevention)
	$('a.email').each(function(){
		var pre       = $(this).data('pre');
		var after     = $(this).data('after');
		var textPre   = $(this).data('text-pre');
		var textAfter = $(this).data('text-after');
		$(this).attr('href', 'mailto:' + pre + '@' + after);
		if (textPre) $(this).text(textPre + '@' + textAfter);
	});

	/* left/right placement of tooltips */
	if ($('.content')[0]) {
  	var leftPosContent = $('.content').offset().left;
  	var widthContent   = $('.content').width();
  	$('.hint--bottom').each(function(){
  	  var leftPos = $(this).offset().left;
  	  if (widthContent / 2 < leftPos - leftPosContent) $(this).addClass('hint--leftside');
  	});
	}

	/* collapse and popup large tables */
	$('.table-zoom')
	.each(function(){
	  var minMargin   = 250;
	  var zoombutton  = $(this);
	  var table       = zoombutton.parent();
	  var tableHeight = table.height();
	  var positionTop = tableHeight > 600 ? minMargin : tableHeight / 2;

	  zoombutton.css('top',positionTop+'px');

	  if (tableHeight > 600) {
   	  var tableTop = table.offset().top;
      $(window).scroll(function(){
        var tableScrollPos = $(this).scrollTop() - tableTop;
   	    if (tableScrollPos > 0 && tableScrollPos < tableHeight - tableTop - minMargin) {
     	    positionTop = minMargin + tableScrollPos;
     	    zoombutton.css('top',positionTop+'px');
   	    }
   	  });
   	}
	})
	.click(function(){
	  $(this).parent().addClass('popup');
	})
	;

	$('.table-close').click(function(){
	  $(this).parent().removeClass('popup');
	});

	/* fix left menu on page scroll */
  $(window).scroll(function(){
    var navHeight  = $('.sidebar-left').height();
    var pageHeight = $('.content').height();
    var maxMT      = pageHeight - navHeight - 80;
    if ($(window).height() > navHeight + 20 && pageHeight > navHeight && pageHeight > 1000) {
      var scrollPos = $(this).scrollTop();
      var margintop = scrollPos > 240 ? scrollPos - 240 : 0;
      margintop     = margintop > maxMT ? maxMT : margintop;
      $('.sidebar-left').css('margin-top',margintop);
    }
  });
  
  $('body').on('click', function() {
    $('.noteRefRow.selected').removeClass('selected');
  });
  $('.noteRefRow').on('click', function(e) {
    e.stopPropagation();
    if($(this).hasClass('selected')) {
      $('.noteRefRow.selected').removeClass('selected');
    } else {
      $('.noteRefRow.selected').removeClass('selected');
      $(this).addClass('selected');
    }
  });
  // $('.noteRefTable').each(function(){
    // var indent = $(this).data('indent');
    // console.log('indent:' + indent);
    // $(this).css('margin-left',indent);
  // });
  
  // Fix voor verkeerde vieport height op bijvoorbeeld Ipad 
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  
  // We listen to the resize event
  window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });
});
